import { TeamChannelComponent } from '../../components/Settings/teamChannelSettings'
import React from 'react'
import { useEffectOnce } from 'react-use'
import { AppContent } from '../../components/utils/utils'
import { User } from '../../reducers/userReducer'
import { Organization } from '../../reducers/organizationReducer'
import { useDispatch, useSelector } from 'react-redux'
import { useAxiosWithHeader, useQuery } from '../../utils'
import { SettingsNotOnboarded } from '../../components/SettingsNotOnboarded'
import { setIsOnboarded, PlayerState } from '../../reducers/playersReducer'
import getOrgAndEngineers from '../../api/getOrgAndEngineers'
import { isSlackAuth } from '../../components/TeamChannels/helpers'

function TeamChannelSettings() {
  const user = useSelector(User.selectors.selectUser)
  const organization = useSelector(Organization.selectors.getOrganization)
  const isOnboarded = useSelector(PlayerState.selectors.isOnboarded)
  const axios = useAxiosWithHeader()
  let query = useQuery()
  const dispatch = useDispatch()

  const slackAuth = isSlackAuth({ user, organization })

  useEffectOnce(() => {
    ;(async () => {
      if (user) {
        // why are there two getOrgAndEngineers here?
        // need a time out so we can first get the user in due time
        await setTimeout(() => {
          getOrgAndEngineers({
            organization,
            slackAuth,
            dispatch,
            user,
            axios,
            setIsOnboarded,
          })
        }, 1000)
      }
      if (!organization.slackMembers) {
        getOrgAndEngineers({
          organization,
          slackAuth,
          dispatch,
          user,
          axios,
          setIsOnboarded,
        })
      }
    })()
  }, [axios, dispatch, query, user, getOrgAndEngineers])

  return (
    <div>
      <div className="">
        <AppContent className="mt-4 flex">
          {!isOnboarded && <SettingsNotOnboarded organization={organization} />}
          {isOnboarded && (
            <TeamChannelComponent
              isSelectMembersReady={organization.isSelectMembersReady}
            />
          )}
        </AppContent>
      </div>
    </div>
  )
}

export default TeamChannelSettings
